import { Link } from "react-router-dom";

const HomeMainContent = () => {
  return (
    <>
      <div className="ail-hero-area pt-120 pb-120">
        <div className="container">
          <div className="row align-items-center justify-content-between">


            <div className="col-xl-8">
              <div className="text-left">
                <h1 className="ail-highlighted-text text-black fs-6 text-left">
                  Payments platform
                  for a global operation
                </h1>
                <h1 className="ail-hero-title text-black fs-72">
                  Payments
                  for every customer
                </h1>
                <p className="ail-body-color fs-20 mx-auto">
                  Sunlex is a secure and innovative payment gateway <br />
                  designed for businesses to optimize transactions
                  and expand globally..
                </p>
                <Link
                    to="/register"
                  className="btn ail-gd-bg dark-bg-hover rounded-5 text-white fs-16 border-0 mt-20"
                >
                  Get started
                </Link>
              </div>
            </div>

            <div className="col-xl-4">
              <div className="text-left">
                <img
                    src="assets/img/cr-card.png"
                    alt=""
                    className="ail-hero-img img-fluid"
                />

              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default HomeMainContent;
